<template>
    <div class="code_item" ref="item" :class="{ on: isFocused }" v-if="isShow" @click.stop="action_Select">
        <span class="label" :class="{ custom_code: isCustomnized }" :style="styleString">
            {{ workCodetitle }}
            <a class="mgl_auto" v-if="!hasWorkCode" @click="action_RemoveRecord"><v-icon x-small>mdi-close</v-icon></a>
        </span>
        <div class="staff_wrap" v-if="!isShowSearchLayer" @click.stop="action_Select">
            <div class="staff_placeholder" v-if="employees.length == 0">{{ $t('work_schedule.calendar.placeholder_staff_name') }}</div>
            <EmployeeItem v-for="(employee, index) in employees" :key="index" :employee="employee" />
        </div>
    </div>
</template>

<script>
import { deepCopy } from '@/util/deep-copy'
import { sheetState } from '../../../../../../../sheet-state'
import { workerState, showSearchLayer } from '../../../../worker-state'
const moment = require('@/util/MPMoment')

import EmployeeItem from './CalendarEditEmployeeItem.vue'

export default {
    components: { EmployeeItem },
    props: {
        value: Object,
        index: Number,
        isOverlay: Boolean,
        keyEventController: Object
    },
    data() {
        return {
            sheetState,
            worker: workerState,
            record: {}
        }
    },
    watch: {
        value: {
            immediate: true,
            deep: true,
            handler: function (newValue, oldValue) {
                if (newValue == oldValue) {
                    return
                }
                if (newValue == undefined) {
                    return
                }
                this.record = deepCopy(newValue)
                if (this.isFocused == true) {
                    this.worker.focusedRecord = newValue
                }
            }
        },
        focusedRecord: {
            handler: function () {
                if (this.isFocused == true) {
                    this.worker.f_SelectEmployee = this.selectEmployee
                    this.worker.f_UnselectEmployee = this.unselectEmployee
                    this.worker.focusedElement = this.$refs.item
                }
            }
        },
        'worker.deleteEmployeesInRecord': {
            handler: function (newValue) {
                if (newValue == true && this.isFocused) {
                    for (let i = this.record.employees.length - 1; i >= 0; i--) {
                        this.unselectEmployee(undefined, i)
                    }
                    this.worker.deleteEmployeesInRecord = false
                }
            }
        }
    },
    computed: {
        isShow: function () {
            if (!this.isOverlay) {
                return true
            }

            if (this.record?.isCustomized == true) {
                return this.worker.isShowCustomTimeCode == true
            } else {
                let workCodeID = this.record?.workCodeID?._id
                let selectedWorkCodeIDs = this.selectedWorkCodes.map((c) => c._id)
                return selectedWorkCodeIDs.includes(workCodeID)
            }
        },
        isCustomnized: function () {
            return this.record?.isCustomized ?? false
        },
        searchLayer_Key: function () {
            return this.worker.searchLayer_Key
        },
        isShowSearchLayer: function () {
            let key = this.searchLayer_Key
            if (this.record.isCustomized == true) {
                let keyS = moment(key?.startedAt).format()
                let keyE = moment(key?.endedAt).format()
                let recS = moment(this.record.startedAt).format()
                let recE = moment(this.record.endedAt).format()
                if (key?.hospitalID == this.record.hospitalID && key?.date == this.record.date && keyS == recS && keyE == recE) {
                    return true
                }
            } else {
                let keyDate = moment(key?.date).format()
                let recDate = moment(this.record.date).format()
                if (key?.hospitalID == this.record.hospitalID && key?.workCodeID?._id == this.record.workCodeID?._id && keyDate == recDate) {
                    return true
                }
            }
            return false
        },
        selectedWorkCodes: function () {
            return this.worker.workCodes.filter((c) => c.isSelected)
        },
        isFocused: function () {
            if (this.focusedRecord == undefined) {
                return false
            }
            if (this.value.isCustomized == true) {
                if (this.value.date == this.focusedRecord.date && this.value.startedAt == this.focusedRecord.startedAt && this.value.endedAt == this.focusedRecord.endedAt) {
                    return true
                }
            } else {
                if (
                    this.value.date == this.focusedRecord.date &&
                    (this.value.workCodeID?._id == this.focusedRecord.workCodeID?._id || this.value.workCodeID == this.focusedRecord.workCodeID)
                ) {
                    return true
                }
            }
            return false
        },
        focusedRecord: function () {
            return this.worker.focusedRecord
        },
        hasWorkCode: function () {
            return this.workCode._id != undefined
        },
        workCode: function () {
            return this.worker.workCodes?.find((c) => c._id == this.value.workCodeID?._id) ?? {}
        },
        reservationSetting: function () {
            return this.sheetState.reservationSetting
        },
        palette: function () {
            return this.reservationSetting?.workCodeColorPaletteID?.basicPalette
        },
        paletteIndex: function () {
            return this.workCode.paletteIndex
        },
        hasCustomPalette: function () {
            return this.workCode.usingCustomColor ?? false
        },
        textColor: function () {
            if (this.backgroundColor == '#FFF') {
                return '#000'
            }
            let color = this.backgroundColor.slice(1)
            let rgb = parseInt(color, 16) // 16진수를 10진수로 변환
            let r = (rgb >> 16) & 0xff
            let g = (rgb >> 8) & 0xff
            let b = (rgb >> 0) & 0xff
            let brightness = 0.299 * r + 0.587 * g + 0.114 * b
            if (brightness > 111) {
                return '#000'
            }
            return '#FFF'
        },
        backgroundColor: function () {
            if (this.hasCustomPalette == true) {
                return this.workCode.customColorCode
            }
            if (this.hasWorkCode == false) {
                return '#FFF'
            }
            return this.palette[this.paletteIndex]
        },
        styleString: function () {
            let string = 'background-color: ' + this.backgroundColor + '; ' + 'color: ' + this.textColor + ';'
            if (this.hasWorkCode == false) {
                string += ' border: ' + '1px solid #929292;' + 'z-index: 2;'
            }
            return string
        },
        workCodetitle: function () {
            if (this.hasWorkCode) {
                return this.workCode.title
            }
            let start = moment(this.value.startedAt)
            let end = moment(this.value.endedAt)
            return start.format('HH:mm') + '~' + end.format('HH:mm')
        },
        employees: function () {
            return this.record.employees
        },
        searchLayerKey: function () {
            return {
                _id: this.record._id,
                hospitalID: this.record.hospitalID,
                date: this.record.date,
                workCodeID: this.record.workCodeID,
                isCustomized: this.record.isCustomized,
                startedAt: this.record.startedAt,
                endedAt: this.record.endedAt
            }
        }
    },
    methods: {
        // MARK: - Actions
        action_Focus() {
            this.worker.focusedRecord = this.value
        },
        action_RemoveRecord() {
            this.$emit('removeRecord', this.value, this.index)
        },
        action_Select() {
            this.action_Focus()
            showSearchLayer(this.searchLayerKey)
        },

        // MARK: - Emit
        selectEmployee(employee) {
            this.record.employees.push(employee)
            this.updateValue()
        },
        unselectEmployee(_, index) {
            this.record.employees.splice(index, 1)
            this.updateValue()
        },
        updateValue() {
            this.$emit('updateValue', this.record, this.index)
        }
    }
}
</script>

<style scoped>
.v2_rsv .schedule .schedule_calendar_wrap .day_wrap .day_edit .code_item .custom_code {
    min-width: 95px;
    /* 20240526 지호
            근무일정 시간 직접 설정시 라벨 최소 너비값 정의
        */
}
</style>
